<div class="eventos-linea__pagina">
  @if (loadError()) {
    <p class="m-0 mb-3 text-color-secondary">No pudimos cargar los eventos.</p>
    <p-button label="Reintentar" icon="pi pi-refresh" [outlined]="true" (onClick)="reintentar()" />
  } @else if (loading()) {
    <app-skeleton-block variant="list" [rows]="4" />
  } @else if (linea().length === 0) {
    <div class="eventos-linea__vacio">
      <p class="m-0 text-xl font-semibold">Aún no hay eventos.</p>
      <p class="m-0 mt-2 text-color-secondary">
        Cuando un administrador agende uno, va a aparecer en esta línea de tiempo.
      </p>
    </div>
  } @else {
    <div class="eventos-linea">
      <p-timeline [value]="linea()" align="alternate">
        <ng-template #opposite let-evento>
          <div class="eventos-linea__fecha" [class.eventos-linea__pasado]="esPasado(evento)">
            <span>{{ fechaCorta(evento) }}</span>
            <span class="eventos-linea__cuando">{{ cuando(evento) }}</span>
          </div>
        </ng-template>
        <ng-template #marker let-evento>
          <span
            class="eventos-linea__marca"
            [attr.data-color]="colorMarca(evento)"
            [class.eventos-linea__marca--pasado]="esPasado(evento)"
          >
            @if (claseIcono(evento); as clase) {
              <i [class]="clase" aria-hidden="true"></i>
            } @else {
              <span class="eventos-linea__punto" aria-hidden="true"></span>
            }
          </span>
        </ng-template>
        <ng-template #content let-evento>
          <article class="eventos-linea__tarjeta" [class.eventos-linea__pasado]="esPasado(evento)">
            <p class="m-0 font-semibold">{{ evento.nombre }}</p>
            @if (detalle(evento); as publico) {
              <p class="m-0 mt-1 text-sm text-color-secondary">{{ publico }}</p>
            }
            @if (evento.comentario) {
              <p class="eventos-linea__comentario m-0 mt-2">{{ evento.comentario }}</p>
            }
          </article>
        </ng-template>
      </p-timeline>
    </div>
  }
</div>
